module.exports = __webpack_public_path__ + "img/1540295605.abca0693.jpg";